import { prop } from '@rxweb/reactive-form-validators';
import { Language } from '../../../shared/global';
export interface IBaseEntity{
  id: number;
}
export class BaseEntity implements IBaseEntity {
  static currentLanguage = Language.French;
  @prop() id: any = null;
}
